(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["babybaraka-name-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBabyBarakaQuiz = (scope = document) => {
      const roots = scope.querySelectorAll ? scope.querySelectorAll('[data-bb-quiz-root]:not([data-bb-quiz-ready])') : [];

      roots.forEach((root) => {
        root.setAttribute('data-bb-quiz-ready', 'true');

        // EDIT QUESTIONS HERE.
        // The public funnel keeps the final 11-step BabyBaraka journey.
        // kind: "question" creates a real question.
        // type: "single" allows one answer.
        // type: "multi" allows several answers and keeps every selected card marked.
        // progressStep controls the visible "Step X of 11" number.
        const quizScreens = [
          {
            kind: 'intro',
            progressStep: 1,
            brand: 'BabyBaraka',
            title: "Find Your Baby's Name Style",
            text: "Answer a few honest questions and discover your baby's name style \u2014 shaped by your faith, preferences and real family life.",
            footnote: 'Takes less than 2 minutes',
            button: 'Start Quiz'
          },
          {
            kind: 'question',
            id: 'babyType',
            progressStep: 1,
            type: 'single',
            question: 'Who are you looking for a name for?',
            helper: 'Choose one',
            options: ['Baby girl', 'Baby boy', 'Twins / two babies', "We don't know yet"]
          },
          {
            kind: 'question',
            id: 'babyJourney',
            progressStep: 2,
            type: 'single',
            helper: 'Choose one',
            question: 'Where are you in your baby journey?',
            options: ['Planning for the future', 'Pregnant and still have time', 'Baby is coming soon', 'Baby is already here']
          },
          {
            kind: 'question',
            id: 'nameStyles',
            progressStep: 3,
            type: 'multi',
            max: 2,
            helper: 'Choose up to two',
            maxMessage: 'You can choose up to two.',
            question: 'Which name style feels closest to you?',
            options: ['Soft and modern', 'Classic and timeless', 'Rare but meaningful', 'Easy to use internationally', 'Elegant and refined']
          },
          {
            kind: 'question',
            id: 'origins',
            progressStep: 4,
            type: 'multi',
            max: 2,
            helper: 'Choose up to two',
            maxMessage: 'You can choose up to two.',
            question: 'Which origins would you like us to focus on?',
            options: ['Arabic', 'North African / Maghrebi', 'Turkish or Persian', 'South Asian', 'African', 'Mixed origins', 'No preference']
          },
          {
            kind: 'note',
            progressStep: 5,
            title: 'A beautiful sound is only the beginning.',
            text: "The right name should have a beautiful sound, a clear meaning and feel natural in your family's everyday life. Your next answers help us narrow the direction before revealing your name style.",
            button: 'Continue'
          },
          {
            kind: 'question',
            id: 'priorities',
            progressStep: 6,
            type: 'multi',
            max: 2,
            helper: 'Choose up to two',
            maxMessage: 'You can choose up to two.',
            question: 'What matters most to you in a name?',
            options: ['A beautiful meaning', 'A beautiful sound', 'Easy pronunciation', 'Something both parents love', 'A balance of everything']
          },
          {
            kind: 'question',
            id: 'meaningPreferences',
            progressStep: 7,
            type: 'multi',
            max: 2,
            helper: 'Choose up to two',
            maxMessage: 'You can choose up to two.',
            question: 'Which meanings are you most drawn to?',
            options: ['Faith and guidance', 'Strength and courage', 'Mercy and kindness', 'Peace and wisdom', 'Beauty and grace', 'No specific preference']
          },
          {
            kind: 'question',
            id: 'difficulties',
            progressStep: 8,
            type: 'multi',
            helper: 'Select all that apply.',
            question: 'What is making the name decision hardest right now?',
            options: ['Too many lists, I feel lost', "I don't fully trust meanings online", 'My husband or family disagrees', "I want an Islamic name that's also easy to carry in the West", 'I want something rare, not random']
          },
          {
            kind: 'question',
            id: 'avoidances',
            progressStep: 9,
            type: 'multi',
            helper: 'Select all that apply.',
            question: 'What do you most want to avoid?',
            options: ['Choosing a name with the wrong meaning', 'Regretting the name later', 'My child always correcting pronunciation', 'More arguments with family', 'Choosing something too common']
          },
          {
            kind: 'note',
            progressStep: 10,
            title: 'The problem is not finding more names.',
            text: 'The real challenge is knowing which names genuinely fit your baby. Your answers now give us enough direction to reveal the name style shaped by the origin, sound and priorities you chose.',
            button: 'Continue'
          },
          {
            kind: 'capture',
            progressStep: 11,
            title: 'Your Name Style Is Ready.',
            text: "Enter your first name and email to discover your baby's name style \u2014 based on everything you just shared.",
            button: 'Reveal My Style'
          }
        ];

        const nameCatalog = {
          female: {
            arabic: ['Aaliyah','Amina','Amira','Aya','Basma','Bushra','Dana','Dima','Duha','Emaan','Farah','Hala','Hana','Hiba','Hind','Iman','Inaya','Isra','Jana','Jannah','Jumana','Kawthar','Laila','Lama','Lina','Lujain','Maha','Malak','Mariam','Marwa','Nada','Nadine','Noor','Rahma','Rania','Reem','Rima','Ruqayya','Safa','Salma','Sana','Sarah','Shatha','Sumayya','Tasneem','Yara','Yasmin','Zahra','Zaynab','Rasha'],
            turkish_persian: ['Aylin','Duru','Elif','Eylul','Hazal','Ilayda','Irmak','Meryem','Miray','Nisa','Selin','Zeynep','Azra','Esra','Hira','Irem','Leyla','Melek','Nehir','Nisan','Asel','Alara','Beren','Ceyda','Defne','Ecrin','Melis','Mina','Parisa','Yasna'],
            maghrebi: ['Kenza','Ines','Nesrine','Lyna','Sirine','Amel','Nawel','Widad','Souad','Mouna','Samira','Soraya','Lamia','Ghita','Houda','Ikram','Meriem','Nawal','Rym','Sabah','Dounia','Alya','Noura','Imane','Chaima'],
            south_asian: ['Aafiya','Anaya','Arisha','Eshal','Fariha','Haniya','Mahira','Meher','Mishal','Naira','Nimra','Rida','Sabeen','Saira','Zoya','Zunaira','Areeba','Iqra','Kinza','Mahnoor'],
            african: ['Abena','Aminata','Assia','Binta','Faduma','Hawa','Kadija','Kumba','Mariama','Nala','Nia','Safiya','Yacine','Zuri','Imani']
          },
          male: {
            arabic: ['Adam','Adil','Ahmad','Akram','Ali','Amir','Anas','Ayman','Bilal','Elias','Faris','Hamza','Haris','Hassan','Haytham','Ibrahim','Idris','Ilyas','Imran','Ismail','Iyad','Jad','Jamal','Karim','Khalil','Laith','Luay','Malik','Marwan','Mazen','Mounir','Musa','Nabil','Nadir','Nael','Omar','Qasim','Rami','Rayyan','Saad','Sami','Samir','Tariq','Taha','Yasin','Yusuf','Zaid','Zayn','Zakariya','Ziyad'],
            turkish_persian: ['Alp','Aras','Ayaz','Baran','Berat','Burak','Can','Cihan','Demir','Deniz','Emir','Emre','Eren','Kaan','Kerem','Mert','Miran','Onur','Ozan','Selim','Sinan','Timur','Tolga','Umut','Yaman','Arman','Darius','Kian','Navid','Rayan'],
            maghrebi: ['Aksel','Anis','Ayoub','Badr','Chafik','Djibril','Elyes','Fares','Hakim','Hichem','Idir','Ilian','Islem','Kamel','Lyes','Mehdi','Naim','Nassim','Nouh','Reda','Sofiane','Walid','Wassim','Yanis','Younes'],
            south_asian: ['Ayaan','Aariz','Affan','Arham','Danish','Faizan','Huzaifa','Junaid','Ruhan','Rehan','Rishan','Saif','Shahzaib','Shayan','Uzair','Zayan','Zubair','Aahil','Daniyal','Arsal'],
            african: ['Abdou','Amadou','Bakary','Cheikh','Demba','Ibrahima','Khalifa','Mamadou','Moussa','Ousmane','Sekou','Souleymane','Tidiane','Yacouba','Zuberi']
          }
        };

        const resultTypes = {
          soft: {
            title: 'Soft Faith-Fit Names',
            copy: 'You are drawn to a gentle name style: warm, modern, Muslim-friendly, and easy for your child to carry in daily life.',
            reassurance: 'BabyBaraka gives personalized guidance with meaning checked as carefully as possible, while keeping origin, pronunciation, family context, and faith-fit in view.'
          },
          classic: {
            title: 'Classic Islamic Names',
            copy: 'Your answers point toward timeless names with a strong Muslim identity, familiar roots, and a calm sense of tradition.',
            reassurance: 'BabyBaraka is not an imam, scholar, or fatwa service. The goal is personalized guidance, not religious certainty, with meanings checked as carefully as possible.'
          },
          rare: {
            title: 'Rare Meaningful Names',
            copy: 'You seem to want something special and less common, but not random: a name with beauty, meaning, and a thoughtful origin.',
            reassurance: 'Instead of giving you another endless list, BabyBaraka helps narrow the direction so the names feel meaningful, Muslim-friendly, and usable in real life.'
          },
          international: {
            title: 'Easy International Muslim-Friendly Names',
            copy: 'Your style is practical and thoughtful: Muslim-friendly names that are beautiful, easy to pronounce, and comfortable across cultures.',
            reassurance: 'BabyBaraka considers pronunciation, sound, meaning, origin, and family context so the final shortlist feels easier to carry with confidence.'
          },
          balanced: {
            title: 'Premium Balanced Shortlist',
            copy: 'You want the full picture: meaning, faith-fit, beauty, pronunciation, family peace, and a name that feels right for your baby.',
            reassurance: 'BabyBaraka turns scattered ideas into personalized guidance, with a shortlist designed to bring clarity instead of more overwhelm.'
          }
        };

        const offers = {
          basic: {
            title: 'Basic',
            subtitle: '5 Personalized Names',
            description: 'A focused shortlist with meaning and origin, delivered by email in 24-48h.',
            button: 'Choose Basic',
            priceKey: 'basicPrice',
            variantKey: 'basicVariantId',
            urlKey: 'basicProductUrl'
          },
          premium: {
            title: 'Premium',
            subtitle: '10 Personalized Names + 1 Refinement + Milestone Printables',
            badge: 'Most Recommended',
            description: 'Best choice for parents who want more confidence, more options, one refinement, and a beautiful digital milestone bonus.',
            button: 'Choose Premium',
            priceKey: 'premiumPrice',
            variantKey: 'premiumVariantId',
            urlKey: 'premiumProductUrl'
          },
          duo: {
            title: 'Duo / Twins',
            subtitle: '20 Personalized Names',
            description: 'For twins, two babies, or parents who want a complete naming direction.',
            button: 'Choose Duo/Twins',
            priceKey: 'duoPrice',
            variantKey: 'duoVariantId',
            urlKey: 'duoProductUrl'
          }
        };

        const forcedSalesPagePath = '/pages/babybaraka-offer';

        const config = {
          distractionFree: root.dataset.distractionFree === 'true',
          redirectToSales: true,
          salesPageUrl: forcedSalesPagePath,
          enableAddToCart: root.dataset.enableAddToCart === 'true',
          destination: root.dataset.variantDestination || 'checkout',
          basicVariantId: root.dataset.basicVariantId || '',
          premiumVariantId: root.dataset.premiumVariantId || '',
          duoVariantId: root.dataset.duoVariantId || '',
          basicProductUrl: root.dataset.basicProductUrl || '',
          premiumProductUrl: root.dataset.premiumProductUrl || '',
          duoProductUrl: root.dataset.duoProductUrl || '',
          basicPrice: root.dataset.basicPrice || '$14.99',
          premiumPrice: root.dataset.premiumPrice || '$24.99',
          duoPrice: root.dataset.duoPrice || '$34.99',
          resultButtonText: root.dataset.resultButtonText || 'View My Personalized Options',
          milestonePreviewUrl: root.dataset.milestonePreviewUrl || 'https://cdn.shopify.com/s/files/1/0927/5487/0596/files/milestones-preview-3-cards.png?v=1782151578'
        };
        const totalSteps = 11;
        const progressPercents = [0, 9, 18, 27, 36, 45, 55, 64, 73, 82, 91, 100];
        const salesTargetUrl = new URL(forcedSalesPagePath, window.location.origin);
        const isSalesPagePath = salesTargetUrl.origin === window.location.origin
          && normalizePath(salesTargetUrl.pathname) === normalizePath(window.location.pathname);

        if (isSalesPagePath) {
          root.hidden = true;
          root.style.display = 'none';
          document.body.classList.remove('bb-quiz-distraction-free');
          return;
        }

        if (config.distractionFree) {
          document.body.classList.add('bb-quiz-distraction-free');
        }

        const stage = root.querySelector('[data-bb-quiz-stage]');
        const backButton = root.querySelector('[data-bb-quiz-back]');
        const progressFill = root.querySelector('[data-bb-quiz-progress-fill]');
        const stepText = root.querySelector('[data-bb-quiz-step-text]');
        const percentText = root.querySelector('[data-bb-quiz-percent]');
        const storageKey = 'bb-name-quiz-' + (root.dataset.bbQuizSectionId || 'default');

        let state = loadState();
        let screenIndex = Number.isInteger(state.screenIndex) ? state.screenIndex : 0;
        let answers = state.answers || {};
        let lead = state.lead || {};
        let resultKey = state.resultKey || '';
        let recommendedOffer = state.recommendedOffer || '';
        let isCompletingQuiz = false;

        root.addEventListener('click', (event) => {
          const resultButton = event.target.closest('[data-bb-quiz-scroll-offers]');
          if (!resultButton) return;
          event.preventDefault();
          completeQuizAndRedirect();
        });

        function loadState() {
          try {
            return JSON.parse(localStorage.getItem(storageKey)) || {};
          } catch (error) {
            return {};
          }
        }

        function saveState() {
          try {
            const nextState = {
              screenIndex,
              answers,
              lead,
              resultKey,
              recommendedOffer
            };
            localStorage.setItem(storageKey, JSON.stringify(nextState));
            localStorage.setItem('bb-name-quiz-latest', JSON.stringify(nextState));
            localStorage.setItem('babybaraka_quiz_answers', JSON.stringify(buildOfferPayload()));
          } catch (error) {
            // Some browsers block localStorage. The quiz still works during the session.
          }
        }

        function firstValue(id) {
          return answerList(id)[0] || '';
        }

        function labelToSlug(value) {
          return String(value || '')
            .toLowerCase()
            .replace(/&/g, 'and')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
        }

        function resultTitleFromKey(key) {
          return (resultTypes[key] || resultTypes.balanced).title;
        }

        function buildOfferPayload() {
          const styles = answerList('nameStyles');
          const key = resultKey || determineResult();
          return {
            firstName: lead.firstName || '',
            email: lead.email || '',
            babyType: labelToSlug(firstValue('babyType')),
            babyJourney: labelToSlug(firstValue('babyJourney')),
            nameStyles: styles.map(labelToSlug),
            origins: answerList('origins').map(labelToSlug),
            priorities: answerList('priorities').map(labelToSlug),
            meaningPreferences: answerList('meaningPreferences').map(labelToSlug),
            difficulties: answerList('difficulties').map(labelToSlug),
            avoidances: answerList('avoidances').map(labelToSlug),
            primaryStyle: labelToSlug(styles[0] || ''),
            secondaryStyle: labelToSlug(styles[1] || ''),
            resultTitle: resultTitleFromKey(key),
            completedAt: new Date().toISOString(),
            rawAnswers: answers
          };
        }

        function escapeHTML(value) {
          return String(value || '').replace(/[&<>"']/g, (character) => ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
          }[character]));
        }

        function answerList(id) {
          const value = answers[id];
          return Array.isArray(value) ? value : value ? [value] : [];
        }

        function hasAnswer(id, value) {
          return answerList(id).includes(value);
        }

        function updateProgress(screen, isResult) {
          const step = isResult ? totalSteps : (screen && screen.progressStep ? screen.progressStep : 1);
          const percent = isResult ? 100 : (progressPercents[step] || Math.round((step / totalSteps) * 100));
          progressFill.style.width = percent + '%';
          stepText.textContent = isResult ? 'Your results' : 'Step ' + step + ' of ' + totalSteps;
          percentText.textContent = percent + '%';
          backButton.hidden = screenIndex <= 0 || isResult;
        }

        function render() {
          const screen = quizScreens[screenIndex];

          if (!screen) {
            completeQuizAndRedirect();
            return;
          }

          updateProgress(screen, false);

          if (screen.kind === 'intro') renderIntro(screen);
          if (screen.kind === 'question') renderQuestion(screen);
          if (screen.kind === 'note') renderNote(screen);
          if (screen.kind === 'capture') renderCapture(screen);

          saveState();
        }

        function renderIntro(screen) {
          stage.innerHTML = `
            <div class="bb-quiz-screen bb-quiz-intro">
              <div class="bb-quiz-brand">
                <span class="bb-quiz-brand-mark" aria-hidden="true">${moonIcon()}</span>
                <span>${escapeHTML(screen.brand)}</span>
              </div>
              <h1 class="bb-quiz-title">${escapeHTML(screen.title)}</h1>
              <p class="bb-quiz-subtitle">${escapeHTML(screen.text)}</p>
              <div class="bb-quiz-hero-art" aria-hidden="true"></div>
              <div class="bb-quiz-actions">
                <button class="bb-quiz-button" type="button" data-bb-quiz-continue>${escapeHTML(screen.button)}</button>
                ${screen.footnote ? `<p class="bb-quiz-small-note">${escapeHTML(screen.footnote)}</p>` : ''}
              </div>
            </div>
          `;

          stage.querySelector('[data-bb-quiz-continue]').addEventListener('click', () => {
            screenIndex += 1;
            render();
          });
        }

        function renderMilestonePreview() {
          const imageUrl = String(config.milestonePreviewUrl || '').trim();
          const fallbackCards = `
            <div class="bb-quiz-milestone-fallback" aria-label="Milestone card examples">
              <span class="bb-quiz-mini-milestone"><span>Alhamdulillah</span><strong>One</strong><small>MONTH OLD</small></span>
              <span class="bb-quiz-mini-milestone"><span>My First</span><strong>Smile</strong><small>MILESTONE</small></span>
              <span class="bb-quiz-mini-milestone"><span>Bismillah</span><strong>I'm Here</strong><small>NEW BABY</small></span>
            </div>
          `;

          return `
            <div class="bb-quiz-milestone-preview">
              ${imageUrl
                ? `<img src="${escapeHTML(imageUrl)}" alt="Example of BabyBaraka printable milestone cards" loading="lazy">`
                : fallbackCards}
              <p class="bb-quiz-milestone-caption">Example bonus: soft Islamic milestone cards for baby's first moments.</p>
            </div>
          `;
        }

        function renderQuestion(screen) {
          const selected = answerList(screen.id);
          const helper = screen.helper || 'Choose the answer that feels closest.';
          const milestonePreview = screen.id === 'milestones' ? renderMilestonePreview() : '';
          const optionHTML = screen.options.map((option) => {
            const isSelected = selected.includes(option);
            return `
              <button class="bb-quiz-option${isSelected ? ' bb-quiz-selected' : ''}" type="button" data-bb-quiz-answer="${escapeHTML(option)}" aria-pressed="${isSelected ? 'true' : 'false'}">
                <span class="bb-quiz-icon" aria-hidden="true">${optionIcon(option)}</span>
                <span class="bb-quiz-option-label">${escapeHTML(option)}</span>
                <span class="bb-quiz-check" aria-hidden="true">${checkIcon()}</span>
                <span class="bb-quiz-sparkle" aria-hidden="true"></span>
              </button>
            `;
          }).join('');

          stage.innerHTML = `
            <div class="bb-quiz-screen bb-quiz-question-screen">
              <h2 class="bb-quiz-question">${escapeHTML(screen.question)}</h2>
              <p class="bb-quiz-helper">${escapeHTML(helper)}</p>
              ${milestonePreview}
              ${screen.maxMessage ? `<p class="bb-quiz-small-note" data-bb-quiz-limit hidden>${escapeHTML(screen.maxMessage)}</p>` : ''}
              <div class="bb-quiz-options">${optionHTML}</div>
              <div class="bb-quiz-actions">
                <button class="bb-quiz-button" type="button" data-bb-quiz-continue ${selected.length ? '' : 'disabled'}>Continue</button>
              </div>
            </div>
          `;

          stage.querySelectorAll('[data-bb-quiz-answer]').forEach((button) => {
            button.addEventListener('click', (event) => {
              const value = button.dataset.bbQuizAnswer;
              const current = answerList(screen.id);
              addRipple(button, event);

              if (screen.type === 'multi') {
                const max = Number(screen.max || 0);
                if (max && !current.includes(value) && current.length >= max) {
                  const helperEl = stage.querySelector('[data-bb-quiz-limit]');
                  if (helperEl) {
                    helperEl.hidden = false;
                    helperEl.classList.remove('bb-quiz-pop');
                    window.requestAnimationFrame(() => helperEl.classList.add('bb-quiz-pop'));
                  }
                  return;
                }
                answers[screen.id] = current.includes(value)
                  ? current.filter((item) => item !== value)
                  : current.concat(value);
              } else {
                answers[screen.id] = [value];
              }

              saveState();
              renderQuestion(screen);

              const selectedButton = stage.querySelector('[data-bb-quiz-answer="' + cssEscape(value) + '"]');
              if (selectedButton) {
                selectedButton.classList.remove('bb-quiz-pop');
                window.requestAnimationFrame(() => selectedButton.classList.add('bb-quiz-pop'));
              }
            });
          });

          stage.querySelector('[data-bb-quiz-continue]').addEventListener('click', () => {
            if (!answerList(screen.id).length) return;
            screenIndex += 1;
            render();
          });
        }

        function renderNote(screen) {
          stage.innerHTML = `
            <div class="bb-quiz-screen bb-quiz-card-note">
              <div class="bb-quiz-card-note-inner">
                <span class="bb-quiz-card-icon" aria-hidden="true">${heartCircleIcon()}</span>
                <h2 class="bb-quiz-note-title">${escapeHTML(screen.title)}</h2>
                <p class="bb-quiz-note-copy">${escapeHTML(screen.text)}</p>
                <div class="bb-quiz-actions">
                  <button class="bb-quiz-button" type="button" data-bb-quiz-continue>${escapeHTML(screen.button)}</button>
                </div>
              </div>
            </div>
          `;

          stage.querySelector('[data-bb-quiz-continue]').addEventListener('click', () => {
            screenIndex += 1;
            render();
          });
        }

        function renderCapture(screen) {
          stage.innerHTML = `
            <div class="bb-quiz-screen bb-quiz-capture">
              <h2 class="bb-quiz-capture-title">${escapeHTML(screen.title)}</h2>
              <p class="bb-quiz-copy">${escapeHTML(screen.text)}</p>
              <form class="bb-quiz-form" data-bb-quiz-form>
                <div class="bb-quiz-field">
                  <label for="bb-quiz-name-${escapeHTML(root.dataset.bbQuizSectionId || 'default')}">First name</label>
                  <input id="bb-quiz-name-${escapeHTML(root.dataset.bbQuizSectionId || 'default')}" name="first_name" type="text" autocomplete="given-name" placeholder="Amina" value="${escapeHTML(lead.firstName || '')}" required>
                </div>
                <div class="bb-quiz-field">
                  <label for="bb-quiz-email-${escapeHTML(root.dataset.bbQuizSectionId || 'default')}">Email</label>
                  <input id="bb-quiz-email-${escapeHTML(root.dataset.bbQuizSectionId || 'default')}" name="email" type="email" autocomplete="email" placeholder="you@example.com" value="${escapeHTML(lead.email || '')}" required>
                </div>
                <p class="bb-quiz-safe-note">Your answers are safe with us.</p>
                <button class="bb-quiz-button" type="submit">${escapeHTML(screen.button)}</button>
              </form>
            </div>
          `;

          stage.querySelector('[data-bb-quiz-form]').addEventListener('submit', (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            lead = {
              firstName: String(formData.get('first_name') || '').trim(),
              email: String(formData.get('email') || '').trim()
            };
            resultKey = determineResult();
            recommendedOffer = determineOffer();
            completeQuizAndRedirect();
          });
        }

        function determineResult() {
          if (hasAnswer('nameStyles', 'Classic and timeless') || hasAnswer('meaningPreferences', 'Faith and guidance')) return 'classic';
          if (hasAnswer('nameStyles', 'Rare but meaningful') || hasAnswer('difficulties', 'I want something rare, not random') || hasAnswer('avoidances', 'Choosing something too common')) return 'rare';
          if (hasAnswer('nameStyles', 'Easy to use internationally') || hasAnswer('priorities', 'Easy pronunciation') || hasAnswer('difficulties', "I want an Islamic name that's also easy to carry in the West") || hasAnswer('avoidances', 'My child always correcting pronunciation')) return 'international';
          if (hasAnswer('nameStyles', 'Soft and modern') || hasAnswer('nameStyles', 'Elegant and refined') || hasAnswer('priorities', 'A beautiful sound')) return 'soft';
          return 'balanced';
        }

        function determineOffer() {
          if (hasAnswer('babyType', 'Twins / two babies')) return 'duo';
          return 'premium';
        }

        function selectedOriginKeys() {
          const selected = answerList('origins');
          const keys = [];
          if (selected.includes('Arabic')) keys.push('arabic');
          if (selected.includes('North African / Maghrebi')) keys.push('maghrebi');
          if (selected.includes('Turkish or Persian')) keys.push('turkish_persian');
          if (selected.includes('South Asian')) keys.push('south_asian');
          if (selected.includes('African')) keys.push('african');
          return keys.length ? keys : ['arabic', 'maghrebi', 'turkish_persian', 'south_asian', 'african'];
        }

        function stableQuizNumber() {
          const seed = JSON.stringify({
            babyType: answerList('babyType'),
            nameStyles: answerList('nameStyles'),
            origins: answerList('origins'),
            priorities: answerList('priorities'),
            meanings: answerList('meaningPreferences'),
            avoidances: answerList('avoidances')
          });
          let hash = 2166136261;
          for (let index = 0; index < seed.length; index += 1) {
            hash ^= seed.charCodeAt(index);
            hash = Math.imul(hash, 16777619);
          }
          return Math.abs(hash);
        }

        function catalogNames(gender) {
          const catalog = nameCatalog[gender];
          const names = selectedOriginKeys().flatMap((key) => catalog[key] || []);
          return Array.from(new Set(names));
        }

        function originForName(gender, name) {
          const catalog = nameCatalog[gender];
          const entry = Object.keys(catalog).find((key) => catalog[key].includes(name)) || 'arabic';
          return {
            arabic: 'Arabic origin',
            maghrebi: 'Maghrebi connection',
            turkish_persian: 'Turkish / Persian origin',
            south_asian: 'South Asian usage',
            african: 'African Muslim usage'
          }[entry];
        }

        function styleReason() {
          return firstValue('nameStyles') || {
            classic: 'Classic and timeless',
            rare: 'Rare but meaningful',
            international: 'Easy internationally',
            soft: 'Soft and modern',
            balanced: 'Balanced choice'
          }[determineResult()];
        }

        function priorityReason() {
          const priorities = answerList('priorities');
          if (priorities.includes('Easy pronunciation')) return 'Easy to pronounce';
          if (priorities.includes('A beautiful meaning')) return 'Meaning-led choice';
          if (priorities.includes('Something both parents love')) return 'Family-friendly fit';
          if (priorities.includes('A beautiful sound')) return 'Beautiful sound';
          return 'Matches your priorities';
        }

        function nameMatch(gender, offset) {
          const names = catalogNames(gender);
          const styleOffsets = { classic: 3, soft: 11, rare: 23, international: 37, balanced: 47 };
          const index = (stableQuizNumber() + styleOffsets[determineResult()] + offset) % names.length;
          const name = names[index];
          return {
            name,
            reasons: [styleReason(), originForName(gender, name), priorityReason()]
          };
        }

        function selectPersonalizedMatches() {
          const babyType = firstValue('babyType');
          let matches;
          if (babyType === 'Baby girl') {
            matches = [nameMatch('female', 0), nameMatch('female', 17)];
          } else if (babyType === 'Baby boy') {
            matches = [nameMatch('male', 0), nameMatch('male', 17)];
          } else {
            matches = [nameMatch('female', 0), nameMatch('male', 17)];
          }
          if (matches[0].name === matches[1].name) matches[1] = nameMatch(babyType === 'Baby boy' ? 'male' : 'female', 31);
          return matches;
        }

        function renderResult() {
          redirectToSalesPage();
          return;

          const key = resultKey || determineResult();
          const result = resultTypes[key] || resultTypes.balanced;
          const offerKey = recommendedOffer || determineOffer();
          updateProgress(null, true);

          stage.innerHTML = `
            <div class="bb-quiz-screen bb-quiz-result">
              <div class="bb-quiz-result-card">
                <span class="bb-quiz-result-mark" aria-hidden="true">${heartCircleIcon()}</span>
                <span class="bb-quiz-result-eyebrow">Your Name Style Is</span>
                <h2 class="bb-quiz-result-title">${escapeHTML(result.title)}</h2>
                <p class="bb-quiz-result-copy">${escapeHTML(result.copy)}</p>
                <p class="bb-quiz-result-reassurance">${escapeHTML(result.reassurance)}</p>
                <div class="bb-quiz-result-action">
                  <button class="bb-quiz-button" type="button" data-bb-quiz-scroll-offers>${escapeHTML(config.resultButtonText)}</button>
                </div>
              </div>
              <div id="bb-quiz-offers-${escapeHTML(root.dataset.bbQuizSectionId || 'default')}">
                <h3 class="bb-quiz-offer-heading">Choose Your Personalized Shortlist</h3>
                <p class="bb-quiz-offer-subheading">Choose the option that fits your needs best.</p>
              </div>
              <div class="bb-quiz-offers">
                ${Object.keys(offers).map((keyName) => renderOffer(keyName, offers[keyName], keyName === offerKey)).join('')}
              </div>
              <p class="bb-quiz-error" data-bb-quiz-error>Please add a variant ID or product URL for this offer in the Shopify theme editor.</p>
              <div class="bb-quiz-trust">
                <span>${lockIcon()} Meaning checked as carefully as possible</span>
                <span>${heartIcon()} Personalized, not random</span>
                <span>${mailIcon()} Delivered by email in 24-48h</span>
                <span>${moonIcon()} Muslim-friendly guidance</span>
                <span>${lockIcon()} Your data is safe and private</span>
              </div>
              <p class="bb-quiz-footer-line">No guesswork. No endless lists. Just the right names for your baby.</p>
              <p class="bb-quiz-footer-subline">Let BabyBaraka help you give your baby their first blessing with confidence.</p>
            </div>
          `;

          const scrollButton = stage.querySelector('[data-bb-quiz-scroll-offers]');
          if (scrollButton) {
            scrollButton.addEventListener('click', () => {
              const offersTitle = stage.querySelector('#bb-quiz-offers-' + cssEscape(root.dataset.bbQuizSectionId || 'default'));
              if (offersTitle) offersTitle.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
          }

          stage.querySelectorAll('[data-bb-quiz-offer]').forEach((button) => {
            button.addEventListener('click', () => selectOffer(button.dataset.bbQuizOffer, button));
          });

          stage.querySelectorAll('[data-bb-quiz-offer-card]').forEach((card) => {
            card.addEventListener('click', (event) => {
              if (event.target.closest('[data-bb-quiz-offer]')) return;
              const actionButton = card.querySelector('[data-bb-quiz-offer]');
              selectOffer(card.dataset.bbQuizOfferCard, actionButton || card);
            });
            card.addEventListener('keydown', (event) => {
              if (event.key !== 'Enter' && event.key !== ' ') return;
              event.preventDefault();
              const actionButton = card.querySelector('[data-bb-quiz-offer]');
              selectOffer(card.dataset.bbQuizOfferCard, actionButton || card);
            });
          });

          saveState();
        }

        function renderOffer(key, offer, isRecommended) {
          return `
            <article class="bb-quiz-offer${isRecommended ? ' bb-quiz-recommended' : ''}" role="button" tabindex="0" data-bb-quiz-offer-card="${escapeHTML(key)}">
              ${offer.badge ? `<span class="bb-quiz-badge">${escapeHTML(offer.badge)}</span>` : ''}
              <h4 class="bb-quiz-offer-title">${escapeHTML(offer.title)}</h4>
              <span class="bb-quiz-offer-subtitle">${escapeHTML(offer.subtitle)}</span>
              <strong class="bb-quiz-offer-price">${escapeHTML(config[offer.priceKey])}</strong>
              <p class="bb-quiz-offer-desc">${escapeHTML(offer.description)}</p>
              <button class="bb-quiz-button bb-quiz-offer-button${isRecommended ? '' : ' bb-quiz-secondary-button'}" type="button" data-bb-quiz-offer="${escapeHTML(key)}">${escapeHTML(offer.button)}</button>
            </article>
          `;
        }

        function cartAttributes(offerKey) {
          const activeResult = resultTypes[resultKey || determineResult()] || resultTypes.balanced;
          return {
            'BabyBaraka quiz result': activeResult.title,
            'BabyBaraka offer': offers[offerKey].title,
            'BabyBaraka first name': lead.firstName || '',
            'BabyBaraka email': lead.email || '',
            'BabyBaraka baby': answerList('babyType').join(', '),
            'BabyBaraka journey': answerList('babyJourney').join(', '),
            'BabyBaraka style': answerList('nameStyles').join(', '),
            'BabyBaraka origins': answerList('origins').join(', '),
            'BabyBaraka priorities': answerList('priorities').join(', '),
            'BabyBaraka meaning': answerList('meaningPreferences').join(', '),
            'BabyBaraka concern': answerList('difficulties').join(', '),
            'BabyBaraka avoid': answerList('avoidances').join(', '),
            'BabyBaraka milestones': answerList('milestones').join(', ')
          };
        }

        function quizLeadMessage(offerKey) {
          const attrs = cartAttributes(offerKey);
          return [
            'New BabyBaraka quiz lead',
            '',
            'First name: ' + (lead.firstName || ''),
            'Email: ' + (lead.email || ''),
            '',
            'Quiz result: ' + attrs['BabyBaraka quiz result'],
            'Recommended offer: ' + attrs['BabyBaraka offer'],
            '',
            'Baby: ' + attrs['BabyBaraka baby'],
            'Journey: ' + attrs['BabyBaraka journey'],
            'Style: ' + attrs['BabyBaraka style'],
            'Origins: ' + attrs['BabyBaraka origins'],
            'Priorities: ' + attrs['BabyBaraka priorities'],
            'Meaning: ' + attrs['BabyBaraka meaning'],
            'Concern: ' + attrs['BabyBaraka concern'],
            'Avoid: ' + attrs['BabyBaraka avoid'],
            'Milestones: ' + attrs['BabyBaraka milestones'],
            '',
            'Status: Quiz completed, payment not confirmed yet.'
          ].join('\n');
        }

        async function submitQuizLeadToShopify() {
          if (!lead.email) return false;

          try {
            const formspreeOfferKey = recommendedOffer || determineOffer();
            const formspreeAttrs = cartAttributes(formspreeOfferKey);
            const formspreeBody = new FormData();
            formspreeBody.append('_subject', 'New BabyBaraka quiz lead');
            formspreeBody.append('created_at', new Date().toISOString());
            formspreeBody.append('first_name', lead.firstName || '');
            formspreeBody.append('email', lead.email || '');
            formspreeBody.append('quiz_result', formspreeAttrs['BabyBaraka quiz result']);
            formspreeBody.append('recommended_offer', formspreeAttrs['BabyBaraka offer']);
            formspreeBody.append('baby_type', formspreeAttrs['BabyBaraka baby']);
            formspreeBody.append('baby_journey', formspreeAttrs['BabyBaraka journey']);
            formspreeBody.append('style', formspreeAttrs['BabyBaraka style']);
            formspreeBody.append('priorities', formspreeAttrs['BabyBaraka priorities']);
            formspreeBody.append('concern', formspreeAttrs['BabyBaraka concern']);
            formspreeBody.append('avoid', formspreeAttrs['BabyBaraka avoid']);
            formspreeBody.append('looked_where', answerList('looked_where').join(', '));
            formspreeBody.append('milestones', answerList('milestones').join(', '));
            formspreeBody.append('help_wanted', answerList('help').join(', '));
            formspreeBody.append('paid_status', 'not_paid_yet');
            formspreeBody.append('source_url', window.location.href);
            formspreeBody.append('full_message', quizLeadMessage(formspreeOfferKey));

            await Promise.race([
              fetch('https://formspree.io/f/xpqgrerq', {
                method: 'POST',
                body: formspreeBody,
                mode: 'no-cors',
                keepalive: true
              }),
              new Promise((resolve) => window.setTimeout(resolve, 1600))
            ]);

            return true;

            const makeOfferKey = recommendedOffer || determineOffer();
            const makeAttrs = cartAttributes(makeOfferKey);
            const makeBody = new URLSearchParams();
            makeBody.append('created_at', new Date().toISOString());
            makeBody.append('first_name', lead.firstName || '');
            makeBody.append('email', lead.email || '');
            makeBody.append('quiz_result', makeAttrs['BabyBaraka quiz result']);
            makeBody.append('recommended_offer', makeAttrs['BabyBaraka offer']);
            makeBody.append('baby_type', makeAttrs['BabyBaraka baby']);
            makeBody.append('baby_journey', makeAttrs['BabyBaraka journey']);
            makeBody.append('style', makeAttrs['BabyBaraka style']);
            makeBody.append('priorities', makeAttrs['BabyBaraka priorities']);
            makeBody.append('concern', makeAttrs['BabyBaraka concern']);
            makeBody.append('avoid', makeAttrs['BabyBaraka avoid']);
            makeBody.append('looked_where', answerList('looked_where').join(', '));
            makeBody.append('milestones', answerList('milestones').join(', '));
            makeBody.append('help_wanted', answerList('help').join(', '));
            makeBody.append('paid_status', 'not_paid_yet');
            makeBody.append('source_url', window.location.href);
            makeBody.append('full_message', quizLeadMessage(makeOfferKey));

            await Promise.race([
              fetch('https://hook.eu1.make.com/bmkjq4nkdyigq5u4vjf3f3695t5tg84k', {
                method: 'POST',
                body: makeBody.toString(),
                mode: 'no-cors',
                keepalive: true
              }),
              new Promise((resolve) => window.setTimeout(resolve, 1600))
            ]);

            return true;

            const offerKey = recommendedOffer || determineOffer();
            const body = new URLSearchParams();
            body.append('form_type', 'contact');
            body.append('utf8', '✓');
            body.append('contact[name]', lead.firstName || 'BabyBaraka quiz lead');
            body.append('contact[email]', lead.email);
            body.append('contact[tags]', 'babybaraka-quiz-lead,quiz-completed');
            body.append('contact[body]', quizLeadMessage(offerKey));

            const request = fetch('/contact', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
              body: body.toString(),
              credentials: 'same-origin'
            });

            const response = await Promise.race([
              request,
              new Promise((resolve) => window.setTimeout(() => resolve(null), 1600))
            ]);

            return !response || response.ok;
          } catch (error) {
            // Lead capture is helpful, but it should never block the funnel.
            return false;
          }
        }

        function urlWithQuizParams(url, offerKey) {
          const target = new URL(url, window.location.origin);
          const attrs = cartAttributes(offerKey);
          target.searchParams.set('quiz_result', attrs['BabyBaraka quiz result']);
          target.searchParams.set('selected_offer', attrs['BabyBaraka offer']);
          target.searchParams.set('baby_type', attrs['BabyBaraka baby']);
          target.searchParams.set('style', attrs['BabyBaraka style']);
          return target.toString();
        }

        function normalizePath(path) {
          return String(path || '').replace(/\/+$/, '') || '/';
        }

        function salesPageUrlWithQuizParams() {
          const offerKey = recommendedOffer || determineOffer();
          const target = new URL(forcedSalesPagePath, window.location.origin);
          const attrs = cartAttributes(offerKey);
          const matches = selectPersonalizedMatches();
          target.searchParams.set('quiz_result', attrs['BabyBaraka quiz result']);
          target.searchParams.set('selected_offer', attrs['BabyBaraka offer']);
          target.searchParams.set('baby_type', attrs['BabyBaraka baby']);
          target.searchParams.set('style', attrs['BabyBaraka style']);
          target.searchParams.set('priority', attrs['BabyBaraka priorities']);
          target.searchParams.set('concern', attrs['BabyBaraka concern']);
          target.searchParams.set('priorities', attrs['BabyBaraka priorities']);
          target.searchParams.set('origins', attrs['BabyBaraka origins']);
          target.searchParams.set('meaning_preferences', attrs['BabyBaraka meaning']);
          target.searchParams.set('difficulties', attrs['BabyBaraka concern']);
          target.searchParams.set('avoidances', attrs['BabyBaraka avoid']);
          target.searchParams.set('journey', attrs['BabyBaraka journey']);
          target.searchParams.set('baby_journey', attrs['BabyBaraka journey']);
          target.searchParams.set('bb_quiz_done', '1');
          target.searchParams.set('bb_name_1', matches[0].name);
          target.searchParams.set('bb_name_2', matches[1].name);
          matches.forEach((match, nameIndex) => {
            match.reasons.forEach((reason, reasonIndex) => {
              target.searchParams.set(`bb_reason_${nameIndex + 1}_${reasonIndex + 1}`, reason);
            });
          });
          try {
            localStorage.setItem('babybaraka_quiz_matches', JSON.stringify({
              bb_name_1: matches[0].name,
              bb_name_2: matches[1].name,
              bb_reason_1_1: matches[0].reasons[0],
              bb_reason_1_2: matches[0].reasons[1],
              bb_reason_1_3: matches[0].reasons[2],
              bb_reason_2_1: matches[1].reasons[0],
              bb_reason_2_2: matches[1].reasons[1],
              bb_reason_2_3: matches[1].reasons[2],
              style: attrs['BabyBaraka style'],
              origins: attrs['BabyBaraka origins'],
              priority: attrs['BabyBaraka priorities'],
              avoidances: attrs['BabyBaraka avoid']
            }));
          } catch (error) {}
          return target.toString();
        }

        async function completeQuizAndRedirect() {
          if (isCompletingQuiz) return;
          isCompletingQuiz = true;
          resultKey = resultKey || determineResult();
          recommendedOffer = recommendedOffer || determineOffer();
          screenIndex = quizScreens.length;
          saveState();

          const targetUrl = salesPageUrlWithQuizParams();
          stage.innerHTML = `
            <div class="bb-quiz-screen bb-quiz-card-note">
              <div class="bb-quiz-card-note-inner">
                <span class="bb-quiz-card-icon" aria-hidden="true">${sparkleIcon()}</span>
                <h2 class="bb-quiz-note-title">Preparing your personalized name style...</h2>
                <p class="bb-quiz-note-copy">One moment, we are taking you to your BabyBaraka results.</p>
              </div>
            </div>
          `;

          await submitQuizLeadToShopify();

          window.setTimeout(() => {
            window.location.assign(targetUrl);
            window.setTimeout(() => {
              window.location.href = targetUrl;
            }, 260);
          }, 80);
        }

        function redirectToSalesPage() {
          completeQuizAndRedirect();
        }

        async function selectOffer(offerKey, button) {
          const offer = offers[offerKey];
          const variantId = String(config[offer.variantKey] || '').trim();
          const productUrl = String(config[offer.urlKey] || '').trim();
          const error = stage.querySelector('[data-bb-quiz-error]');

          if (error) error.classList.remove('bb-quiz-show');

          if (config.enableAddToCart && variantId) {
            const oldText = button.textContent;
            button.disabled = true;
            button.textContent = 'Adding...';

            try {
              const attributes = cartAttributes(offerKey);
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({
                  id: Number(variantId),
                  quantity: 1,
                  properties: Object.assign({}, attributes, {
                    '_BabyBaraka quiz': 'Name style quiz'
                  })
                })
              });

              if (!response.ok) throw new Error('Add to cart failed');

              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ attributes })
              });

              window.location.href = config.destination === 'cart' ? '/cart' : '/checkout';
              return;
            } catch (event) {
              button.disabled = false;
              button.textContent = oldText;
              if (productUrl) {
                window.location.href = urlWithQuizParams(productUrl, offerKey);
                return;
              }
              if (error) error.classList.add('bb-quiz-show');
              return;
            }
          }

          if (productUrl) {
            window.location.href = urlWithQuizParams(productUrl, offerKey);
            return;
          }

          if (variantId) {
            window.location.href = '/cart/' + encodeURIComponent(variantId) + ':1' + (config.destination === 'cart' ? '' : '?checkout');
            return;
          }

          if (error) error.classList.add('bb-quiz-show');
        }

        function cssEscape(value) {
          if (window.CSS && CSS.escape) return CSS.escape(value);
          return String(value).replace(/["\\]/g, '\\$&');
        }

        function addRipple(button, event) {
          const rect = button.getBoundingClientRect();
          const ripple = document.createElement('span');
          const x = event && event.clientX ? event.clientX - rect.left : rect.width / 2;
          const y = event && event.clientY ? event.clientY - rect.top : rect.height / 2;
          ripple.className = 'bb-quiz-ripple';
          ripple.style.left = x + 'px';
          ripple.style.top = y + 'px';
          button.appendChild(ripple);
          window.setTimeout(() => ripple.remove(), 560);
        }

        function optionIcon(option) {
          const text = option.toLowerCase();
          let emoji = '✨';
          if (text.includes('girl')) emoji = '🎀';
          else if (text.includes('boy')) emoji = '⭐';
          else if (text.includes('twin') || text.includes('two')) emoji = '👶👶';
          else if (text.includes('sure') || text.includes('maybe')) emoji = '❔';
          else if (text.includes('soft') || text.includes('beautiful') || text.includes('love')) emoji = '🤎';
          else if (text.includes('classic') || text.includes('islamic') || text.includes('imam') || text.includes('identity')) emoji = '🌙';
          else if (text.includes('rare')) emoji = '💎';
          else if (text.includes('pronounce') || text.includes('international') || text.includes('west') || text.includes('carry')) emoji = '🌍';
          else if (text.includes('meaning') || text.includes('trust') || text.includes('google')) emoji = '🔎';
          else if (text.includes('family') || text.includes('husband') || text.includes('parents')) emoji = '👨‍👩‍👧';
          else if (text.includes('pregnant') || text.includes('started')) emoji = '🌱';
          else if (text.includes('coming soon')) emoji = '⏳';
          else if (text.includes('already here')) emoji = '👶';
          else if (text.includes('tiktok') || text.includes('instagram') || text.includes('planning')) emoji = '✨';
          else if (text.includes('apps')) emoji = '📲';
          else if (text.includes('wrong')) emoji = '⚠️';
          else if (text.includes('regretting')) emoji = '💭';
          else if (text.includes('correcting')) emoji = '🗣️';
          else if (text.includes('common')) emoji = '🔁';
          else if (text.includes('short list') || text.includes('focused')) emoji = '📝';
          else if (text.includes('deeper')) emoji = '⭐';
          else if (text.includes('yes')) emoji = '🎀';
          return '<span class="bb-quiz-emoji" aria-hidden="true">' + emoji + '</span>';
        }

        function checkIcon() {
          return '<svg viewBox="0 0 24 24"><path d="m6 12 4 4 8-9"></path></svg>';
        }

        function moonIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M15.6 3.4A8.5 8.5 0 1 0 20.6 14 6.4 6.4 0 0 1 15.6 3.4Z"></path><path d="M18 5.5l.4 1.1 1.1.4-1.1.4L18 8.5l-.4-1.1-1.1-.4 1.1-.4L18 5.5Z"></path></svg>';
        }

        function heartIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M12 21c-4-2.7-7-5.5-7-9.2A4.7 4.7 0 0 1 12 7a4.7 4.7 0 0 1 7 4.8c0 3.7-3 6.5-7 9.2Z"></path></svg>';
        }

        function heartCircleIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M12 21c-4-2.7-7-5.5-7-9.2A4.7 4.7 0 0 1 12 7a4.7 4.7 0 0 1 7 4.8c0 3.7-3 6.5-7 9.2Z"></path><path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z"></path></svg>';
        }

        function sparkleIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z"></path><path d="M19 15l.7 2.3L22 18l-2.3.7L19 21l-.7-2.3L16 18l2.3-.7L19 15Z"></path></svg>';
        }

        function starIcon() {
          return '<svg viewBox="0 0 24 24"><path d="m12 3 2.7 5.5 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.8 1-6.1-4.4-4.3 6.1-.9L12 3Z"></path></svg>';
        }

        function peopleIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"></path><path d="M15 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"></path><path d="M4 20a5 5 0 0 1 10 0"></path><path d="M10 20a5 5 0 0 1 10 0"></path></svg>';
        }

        function questionIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M9.4 9a3 3 0 0 1 5.8 1.1c0 2.4-3.2 2.5-3.2 5"></path><path d="M12 19h.01"></path><path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z"></path></svg>';
        }

        function globeIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z"></path><path d="M3.6 9h16.8"></path><path d="M3.6 15h16.8"></path><path d="M12 3a14 14 0 0 1 0 18"></path><path d="M12 3a14 14 0 0 0 0 18"></path></svg>';
        }

        function lockIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M7 11V8a5 5 0 0 1 10 0v3"></path><rect x="5" y="11" width="14" height="10" rx="2"></rect><path d="M12 15v2"></path></svg>';
        }

        function mailIcon() {
          return '<svg viewBox="0 0 24 24"><rect x="3" y="6" width="18" height="12" rx="1.5"></rect><path d="m3 7 9 7 9-7"></path></svg>';
        }

        backButton.addEventListener('click', () => {
          if (screenIndex <= 0) return;
          screenIndex -= 1;
          render();
        });

        if (screenIndex >= quizScreens.length) {
          screenIndex = 0;
          answers = {};
          lead = {};
          resultKey = '';
          recommendedOffer = '';
          saveState();
        }

        screenIndex = Math.min(screenIndex, quizScreens.length - 1);
        render();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initBabyBarakaQuiz());
    } else {
      initBabyBarakaQuiz();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initBabyBarakaQuiz(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babybaraka-offer-image-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clean = (value) => value ? value.replace(/\+/g, ' ').replace(/[|_]+/g, ', ').replace(/\s*,\s*/g, ', ').trim() : '';
    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const params = new URLSearchParams(window.location.search);
      const config = JSON.parse(root.querySelector('[data-bb-config]').textContent);
      const fields = {
        result: clean(params.get('quiz_result') || params.get('style')),
        meaning: clean(params.get('meaning_preferences')),
        origin: clean(params.get('origins')),
        avoid: clean(params.get('avoidances'))
      };
      const mappings = [
        ['[data-bb-result]', fields.result],
        ['[data-bb-style]', fields.result],
        ['[data-bb-meaning]', fields.meaning],
        ['[data-bb-origin]', fields.origin],
        ['[data-bb-avoid]', fields.avoid]
      ];
      mappings.forEach(([selector, value]) => {
        const node = root.querySelector(selector);
        if (node && value) node.textContent = value;
      });
      root.querySelectorAll('[data-bb-card]').forEach((card) => {
        const key = card.dataset.bbCard;
        if (!fields[key] && key !== 'meaning') card.hidden = true;
      });
      const resultCopy = root.querySelector('[data-bb-result-copy]');
      if (resultCopy && fields.result) resultCopy.textContent = `You’re drawn to ${fields.result.toLowerCase()} — now let’s turn that direction into a shortlist made around what matters to your family.`;
      const error = root.querySelector('[data-bb-error]');
      const previewDialog = root.querySelector('[data-bb-preview-dialog]');
      const previewImage = root.querySelector('[data-bb-preview-image]');
      root.querySelectorAll('[data-bb-preview]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const image = trigger.querySelector('img');
          if (!previewDialog || !previewImage || !image) return;
          previewImage.src = image.currentSrc || image.src;
          previewImage.alt = image.alt;
          previewDialog.showModal();
        });
      });
      root.querySelector('[data-bb-preview-close]')?.addEventListener('click', () => previewDialog?.close());
      previewDialog?.addEventListener('click', (event) => {
        if (event.target === previewDialog) previewDialog.close();
      });
      const sticky = root.querySelector('[data-bb-sticky]');
      const shortlist = root.querySelector('.bb-shortlist__pages');
      const bonuses = root.querySelector('.bb-bonus-swipe');
      if (sticky && shortlist && bonuses) {
        const updateSticky = () => {
          const shortlistTop = shortlist.getBoundingClientRect().top;
          const bonusesTop = bonuses.getBoundingClientRect().top;
          sticky.classList.toggle('is-on', shortlistTop <= window.innerHeight * .65 && bonusesTop > window.innerHeight * .25);
        };
        window.addEventListener('scroll', updateSticky, { passive: true });
        updateSticky();
      }
      root.querySelectorAll('[data-bb-buy]').forEach((button) => {
        button.addEventListener('click', async () => {
          const variantId = Number(config.variantId);
          if (!variantId) return;
          const original = button.innerHTML;
          button.disabled = true;
          button.textContent = 'Opening secure checkout…';
          try {
            await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
            const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1 }) });
            if (!response.ok) throw new Error('Cart error');
            window.location.href = '/checkout';
          } catch (event) {
            button.disabled = false;
            button.innerHTML = original;
            error.textContent = 'Something went wrong. Please try again.';
            error.classList.add('is-visible');
          }
        });
      });
    };
    document.querySelectorAll('[data-bb-image-offer]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-bb-image-offer]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babybaraka-offer-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const boot = (root) => {
      if (!root || root.dataset.bbv2Ready === '1') return;
      root.dataset.bbv2Ready = '1';
      const p = new URLSearchParams(window.location.search);
      const keys = ['quiz_result','style','origins','priorities','priority','meaning_preferences','avoidances','difficulties','journey','baby_journey','baby_type','bb_quiz_done'];
      const hasCtx = keys.some((k) => p.has(k));

      const set = (sel, text) => { const n = root.querySelector(sel); if (n) n.textContent = text; };

      if (!hasCtx) {
        root.querySelectorAll('[data-bbv2-personal]').forEach((n) => { n.hidden = true; });
        const badge = root.querySelector('[data-bbv2-badge]');
        if (badge) badge.hidden = true;
        const quizlink = root.querySelector('[data-bbv2-quizlink]');
        if (quizlink) quizlink.hidden = false;
        set('[data-bbv2-eyebrow]', 'A personalized shortlist of');
        set('[data-bbv2-result]', 'Muslim Baby Names That Truly Fit');
        set('[data-bbv2-lead]', 'Ten names chosen around your taste, values, origins and everyday life — each with its meaning, origin and the reason it fits your family.');
        set('[data-bbv2-note]', 'Answer a few questions and we build the shortlist around you.');
        set('[data-bbv2-scrolltext]', 'See what you receive');
        set('[data-bbv2-bridge-kicker]', 'The real problem');
        const bridgeTitle = root.querySelector('[data-bbv2-bridge-title]');
        if (bridgeTitle) bridgeTitle.innerHTML = 'You don’t need more names. <em>You need the right ones.</em>';
        set('[data-bbv2-receive-title]', 'Your preferences, turned into 10 real names');
        set('[data-bbv2-receive-sub]', 'Each one chosen around your answers — with its meaning, origin, and why it fits your family.');
        return;
      }

      const result = p.get('quiz_result');
      if (result) set('[data-bbv2-result]', result);

      const leadFor = (r) => {
        const s = (r || '').toLowerCase();
        if (s.includes('classic') && s.includes('rare')) return 'You are looking for names that feel timeless and meaningful, yet distinctive enough to feel truly yours.';
        if (s.includes('classic')) return 'You are looking for names that feel meaningful, Muslim-friendly, easy to pronounce, and beautiful to carry in real life.';
        if (s.includes('rare')) return 'You are looking for names that feel distinctive and meaningful, without ever feeling invented or hard to carry.';
        if (s.includes('international')) return 'You are looking for names that honour your faith and still feel natural to pronounce wherever your child grows up.';
        if (s.includes('soft')) return 'You are looking for names that feel gentle, meaningful and easy for your child to carry every day.';
        return 'You are looking for names that feel meaningful, Muslim-friendly, easy to pronounce, and beautiful to carry in real life.';
      };
      set('[data-bbv2-lead]', leadFor(result));

      const first = (...names) => {
        for (const n of names) { const v = p.get(n); if (v) return v; }
        return '';
      };
      const rows = [
        ['☆', 'Name style', first('style','quiz_result')],
        ['♡', 'What matters most', first('priorities','priority')],
        ['◎', 'Origins you want', first('origins')],
        ['✧', 'Meanings you love', first('meaning_preferences')],
        ['✕', 'What to avoid', first('avoidances','difficulties')],
        ['☾', 'Baby journey', first('journey','baby_journey')]
      ].filter((r) => r[2]);

      const recap = root.querySelector('[data-bbv2-recap]');
      const recapCard = root.querySelector('.bbv2-recap');
      if (recap && rows.length) {
        if (recapCard) recapCard.hidden = false;
        rows.forEach(([icon, label, value], i) => {
          const row = document.createElement('div');
          row.className = 'bbv2-recap__row';
          const ic = document.createElement('span');
          ic.className = 'bbv2-recap__ico';
          ic.setAttribute('aria-hidden', 'true');
          ic.textContent = icon;
          const box = document.createElement('div');
          const st = document.createElement('strong');
          st.textContent = (i + 1) + '. ' + label;
          const vl = document.createElement('span');
          vl.className = 'v';
          vl.textContent = value;
          box.append(st, vl);
          row.append(ic, box);
          recap.appendChild(row);
        });
      }

      const tagBox = root.querySelector('[data-bbv2-tags]');
      const tagCard = root.querySelector('.bbv2-tags');
      if (tagBox) {
        const seen = new Set();
        [first('quiz_result'), first('style'), first('priorities','priority'), first('origins')]
          .filter(Boolean)
          .flatMap((v) => v.split(','))
          .map((v) => v.trim())
          .filter(Boolean)
          .forEach((v) => {
            const k = v.toLowerCase();
            if (seen.has(k) || seen.size >= 5) return;
            seen.add(k);
            const tag = document.createElement('i');
            tag.textContent = v;
            tagBox.appendChild(tag);
          });
        if (tagCard && seen.size) tagCard.hidden = false;
      }

      root.querySelectorAll('a[href*="/cart/"]').forEach((a) => {
        try {
          const u = new URL(a.getAttribute('href'), window.location.origin);
          keys.concat(['first_name','email']).forEach((k) => {
            const v = p.get(k);
            if (v) u.searchParams.set('attributes[' + k + ']', v);
          });
          a.setAttribute('href', u.pathname + u.search);
        } catch (e) {}
      });
    };

    const extras = (root) => {
      const sticky = root.querySelector('[data-bbv2-sticky]');
      const anchor = root.querySelector('.bbv2-receive');
      const bonuses = root.querySelector('.bbv2-bonuses');
      if (sticky && anchor && bonuses) {
        const updateSticky = () => {
          const shortlistTop = anchor.getBoundingClientRect().top;
          const bonusesTop = bonuses.getBoundingClientRect().top;
          sticky.classList.toggle('is-on', shortlistTop <= window.innerHeight * .65 && bonusesTop > window.innerHeight * .25);
        };
        window.addEventListener('scroll', updateSticky, { passive: true });
        updateSticky();
      }
      const modal = root.querySelector('[data-bbv2-modal]');
      const modalVideo = root.querySelector('[data-bbv2-modal-video]');
      const closeModal = () => {
        if (!modal || !modalVideo) return;
        modalVideo.pause();
        modalVideo.removeAttribute('src');
        modal.hidden = true;
      };
      root.querySelectorAll('[data-bbv2-play]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (!modal || !modalVideo) return;
          modalVideo.src = btn.getAttribute('data-bbv2-play');
          modal.hidden = false;
          modalVideo.play().catch(() => {});
        });
      });
      const closeBtn = root.querySelector('[data-bbv2-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (modal) modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });
    };

    const init = (root) => { if (!root) return; boot(root); extras(root); };
    document.querySelectorAll('[data-bbv2]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-bbv2]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babybaraka-post-quiz-offer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bb-offer').forEach((section) => {
    const config = JSON.parse(section.querySelector('[data-bb-config]').textContent);
    const tabs = section.querySelectorAll('[data-bb-tab]');
    const panels = section.querySelectorAll('[data-bb-panel]');
    const toast = section.querySelector('.bb-toast');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = tab.dataset.bbTab;
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          const active = panel.dataset.bbPanel === index;
          panel.classList.toggle('is-active', active);
          const video = panel.querySelector('video');
          if (video && !active) video.pause();
        });
      });
    });

    section.querySelectorAll('[data-bb-buy]').forEach((button) => {
      button.addEventListener('click', async () => {
        if (!config.variantId) {
          toast.textContent = 'Select the offer product in the theme editor.';
          toast.classList.add('is-visible');
          window.setTimeout(() => toast.classList.remove('is-visible'), 3500);
          return;
        }

        const original = button.innerHTML;
        button.disabled = true;
        button.textContent = 'Adding your package…';

        try {
          const response = await fetch(config.addUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: config.variantId, quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart error');
          window.location.href = config.checkoutUrl;
        } catch (error) {
          button.disabled = false;
          button.innerHTML = original;
          toast.textContent = 'Something went wrong. Please try again.';
          toast.classList.add('is-visible');
          window.setTimeout(() => toast.classList.remove('is-visible'), 3500);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babybaraka-quiz-result"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.bbReady === 'true') return;
      root.dataset.bbReady = 'true';
      const params = new URLSearchParams(window.location.search);
      const result = params.get('quiz_result');
      const content = root.querySelector('[data-bb-result-content]');
      const fallback = root.querySelector('[data-bb-result-fallback]');
      if (!result) {
        if (fallback) fallback.hidden = false;
        return;
      }
      root.classList.add('is-revealing');
      if (content) content.hidden = false;
      const resultProfiles = {
        soft: {
          icon: '\u263e',
          validation: 'Your style reflects a gentle kind of confidence. You are drawn to names that feel warm, faith-conscious and easy for your child to carry every day.',
          traits: ['Warm & gentle', 'Faith-fit', 'Easy to carry']
        },
        classic: {
          icon: '\u2726',
          validation: 'Your style says a lot about you \u2014 you care about meaning as much as sound. Classic names carry generations of intention, and there is real elegance in choosing something timeless.',
          traits: ['Timeless', 'Rooted in faith', 'Generational']
        },
        rare: {
          icon: '\u25c7',
          validation: 'You want a name that feels distinctive without feeling invented. Beauty, meaning and a thoughtful origin matter more to you than simply following what is popular.',
          traits: ['Distinctive', 'Meaning-led', 'Thoughtful']
        },
        international: {
          icon: '\u25c9',
          validation: 'You are choosing with both heart and real life in mind. The right name should feel Muslim-friendly, beautiful and natural to pronounce across the cultures your child will move through.',
          traits: ['Cross-cultural', 'Easy to pronounce', 'Muslim-friendly']
        },
        balanced: {
          icon: '\u2734',
          validation: 'Your answers show a beautifully balanced instinct. You are weighing meaning, faith-fit, sound and everyday ease together rather than compromising on what matters most.',
          traits: ['Well-rounded', 'Meaningful', 'Made for real life']
        },
        classicRare: {
          icon: '\u2727',
          validation: 'Your style says a lot about you \u2014 you care about meaning as much as sound. Classic names carry generations of intention, while a rarer choice lets that timeless beauty feel distinctly yours.',
          traits: ['Timeless', 'Distinctive', 'Meaning-led']
        }
      };
      const normalizedResult = result.toLowerCase();
      let profileKey = 'balanced';
      if (normalizedResult.includes('classic') && normalizedResult.includes('rare')) profileKey = 'classicRare';
      else if (normalizedResult.includes('international')) profileKey = 'international';
      else if (normalizedResult.includes('classic')) profileKey = 'classic';
      else if (normalizedResult.includes('rare')) profileKey = 'rare';
      else if (normalizedResult.includes('soft')) profileKey = 'soft';
      const profile = resultProfiles[profileKey];
      const resultNode = root.querySelector('[data-bb-result]');
      if (resultNode) resultNode.textContent = result;
      const symbol = root.querySelector('[data-bb-result-symbol]');
      const validation = root.querySelector('[data-bb-validation]');
      if (symbol) symbol.textContent = profile.icon;
      if (validation) validation.textContent = profile.validation;
      const revealItems = root.querySelectorAll('.bb-result-page__copy [data-bb-reveal]');
      revealItems.forEach((item, index) => {
        item.style.setProperty('--bb-delay', `${index * 240}ms`);
        item.classList.add('is-visible');
      });
      const ctaCopy = root.querySelector('[data-bb-cta-copy]');
      const preferences = [params.get('origins'), params.get('style')].filter(Boolean).join(', ');
      if (ctaCopy && preferences) {
        ctaCopy.textContent = `Based on what you shared — ${preferences} — we can turn that into a focused shortlist of 10 names, with the meaning, origin and reason each one fits. No more scrolling through the same lists.`;
      }
      const recap = root.querySelector('[data-bb-recap]');
      [
        ['\u2661', 'Meanings', 'meaning_preferences'],
        ['\u25ce', 'Origins', 'origins'],
        ['\u224b', 'Style', 'style'],
        ['\u25c7', 'Avoidances', 'avoidances']
      ].forEach(([icon, label, key], index) => {
        const value = params.get(key);
        if (!value) return;
        const line = document.createElement('div');
        line.className = 'bb-recap__line is-visible';
        line.dataset.bbReveal = '';
        line.style.setProperty('--bb-delay', `${720 + index * 240}ms`);
        const iconNode = document.createElement('span');
        iconNode.className = 'bb-recap__icon';
        iconNode.setAttribute('aria-hidden', 'true');
        iconNode.textContent = icon;
        const labelNode = document.createElement('strong');
        labelNode.className = 'bb-recap__label';
        labelNode.textContent = label;
        const valueNode = document.createElement('span');
        valueNode.className = 'bb-recap__value';
        valueNode.textContent = value;
        line.append(iconNode, labelNode, valueNode);
        recap.appendChild(line);
      });
      if (recap && !recap.children.length) recap.previousElementSibling.hidden = true;
      const shareCard = root.querySelector('[data-bb-share-card]');
      const shareIcon = root.querySelector('[data-bb-share-icon]');
      const shareTitle = root.querySelector('[data-bb-share-title]');
      const shareTraits = root.querySelector('[data-bb-share-traits]');
      const shareStatus = root.querySelector('[data-bb-share-status]');
      if (shareIcon) shareIcon.textContent = profile.icon;
      if (shareTitle) shareTitle.textContent = result;
      if (shareTraits) {
        profile.traits.forEach((trait) => {
          const traitNode = document.createElement('span');
          traitNode.textContent = trait;
          shareTraits.appendChild(traitNode);
        });
      }
      if (shareCard) {
        shareCard.style.setProperty('--bb-delay', '1760ms');
        shareCard.classList.add('is-visible');
      }
      const createShareImage = () => new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        canvas.width = 1080;
        canvas.height = 1080;
        const context = canvas.getContext('2d');
        context.fillStyle = '#f8f3ee';
        context.fillRect(0, 0, 1080, 1080);
        context.strokeStyle = '#d5bda8';
        context.lineWidth = 3;
        context.strokeRect(54, 54, 972, 972);
        context.fillStyle = '#6f4628';
        context.beginPath();
        context.arc(540, 250, 104, 0, Math.PI * 2);
        context.fill();
        context.fillStyle = '#ffffff';
        context.font = '108px serif';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(profile.icon, 540, 250);
        context.fillStyle = '#8c5a31';
        context.font = '700 30px sans-serif';
        context.fillText('YOUR BABYBARAKA NAME STYLE', 540, 420);
        context.fillStyle = '#21150f';
        context.font = '700 62px sans-serif';
        const words = result.split(' ');
        const lines = [];
        let line = '';
        words.forEach((word) => {
          const testLine = line ? `${line} ${word}` : word;
          if (context.measureText(testLine).width > 820 && line) {
            lines.push(line);
            line = word;
          } else {
            line = testLine;
          }
        });
        lines.push(line);
        lines.forEach((titleLine, index) => context.fillText(titleLine, 540, 530 + index * 76));
        context.font = '600 30px sans-serif';
        context.fillStyle = '#6f4628';
        context.fillText(profile.traits.join('  \u2022  '), 540, 760);
        context.font = '700 24px sans-serif';
        context.fillStyle = '#8a7567';
        context.fillText('babybaraka.com', 540, 970);
        canvas.toBlob(resolve, 'image/png');
      });
      const saveCard = async () => {
        const blob = await createShareImage();
        if (!blob) return;
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'my-babybaraka-name-style.png';
        link.click();
        URL.revokeObjectURL(link.href);
        if (shareStatus) shareStatus.textContent = 'Your result card is ready to share.';
      };
      const shareResult = async () => {
        const blob = await createShareImage();
        if (!blob) return;
        const file = new File([blob], 'my-babybaraka-name-style.png', { type: 'image/png' });
        if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
          try {
            await navigator.share({
              title: `My BabyBaraka style: ${result}`,
              text: `My baby-name style is ${result}.`,
              files: [file]
            });
            if (shareStatus) shareStatus.textContent = 'Thanks for sharing your result.';
          } catch (error) {
            if (error.name !== 'AbortError' && shareStatus) shareStatus.textContent = 'Sharing was not available. Try saving the card instead.';
          }
          return;
        }
        await saveCard();
      };
      const saveButton = root.querySelector('[data-bb-save-card]');
      const shareButton = root.querySelector('[data-bb-share-card-button]');
      if (saveButton) saveButton.addEventListener('click', saveCard);
      if (shareButton) shareButton.addEventListener('click', shareResult);
      const forward = root.querySelector('[data-bb-forward]');
      if (forward) forward.href = `/pages/babybaraka-shortlist-offer${window.location.search}`;
    };
    document.querySelectorAll('[data-bb-result-page]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-bb-result-page]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
